<script lang="ts">
	import { homepageData } from "../../data/homepageData.js";
	import Reviews from "../common/Reviews.svelte";
</script>

<Reviews reviews={homepageData.reviews} />
